import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";

/** Un agente come lo vede la NAVIGAZIONE: solo i campi di una voce di menu.
 *  La vigilanza (metriche, salute, canali) resta in `useAdminAgenti`. */
export interface AgenteNav {
  slug: string;
  nome: string;
  stato: "attivo" | "in_arrivo" | "sospeso";
  modulo: string;
}

/** Il roster per la voce «Agenti» della barra. Leggibile da qualunque utente
 *  autenticato: serve a disegnare un menu, non espone contenuti. */
export function useAgenti() {
  return useQuery({
    queryKey: ["agenti", "nav"],
    queryFn: () => apiFetch<{ agenti: AgenteNav[] }>("/api/v1/agenti"),
    staleTime: 5 * 60_000,
  });
}
